import angular from 'angular';
import { AnnouncementsService, AnnouncementsServiceModule } from './announcements.service';
import { AnnouncementsProps } from './announcements.types';

class AnnouncementsController {
  static $inject = ['$element', 'AnnouncementsService'];

  constructor(private $element: JQuery, private announcementsService: AnnouncementsService) {}

  $onInit() {
    this.$element.addClass('acme-announcements');
  }

  getAnnouncements() {
    return this.announcementsService.getAnnouncements();
  }

  dismissAnnouncement(announcement: AnnouncementsProps) {
    this.announcementsService.dismissAnnouncement(announcement);
  }
}

export const AnnouncementsModule = angular
  .module('acme.common.components.announcements', [AnnouncementsServiceModule])
  .component('acmeAnnouncements', {
    templateUrl: 'common/components/announcements/announcements.component.tpl.html',
    controller: AnnouncementsController,
    controllerAs: '$ctrl',
  }).name;
